import { render, staticRenderFns } from "./ChangeTable.vue?vue&type=template&id=462785a5"
import script from "./ChangeTable.vue?vue&type=script&lang=js"
export * from "./ChangeTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports